import React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import {
  getQuestionsAndAnswers,
  selectAppraisal
} from "../../../store/selectors";
import useRadioAndCheckboxQuestionCompact from "../hooks/useRadioAndCheckboxCompact";

interface AnswerObject {
  id: number;
  label: string;
}

interface RadioAndCheckboxProps {
  question: Question;
}

export const RadioAndCheckboxQuestionCompact = ({
  question
}: RadioAndCheckboxProps) => {
  const questionsAndAnswers = useSelector(getQuestionsAndAnswers);
  const storedAnswer = questionsAndAnswers && questionsAndAnswers[question.id];
  const { conditionalAnswersSubmitted } = useSelector(selectAppraisal);

  const {
    noDamage,
    handleSelectChange,
    handleCheckboxChange,
    answersForCheckbox,
    selectAnswer,
    groupName,
    questionString,
    noDamageLabel,
    showCheckboxLabel,
    showCheckboxValue,
    labelForCheckbox
  } = useRadioAndCheckboxQuestionCompact({ question });
  const [toggleCheckbox, setToggleCheckbox] = useState(
     (storedAnswer && (storedAnswer[0] === showCheckboxValue)) ||
      (storedAnswer && storedAnswer[0] !== noDamage)
      ? true
      : false
  );

  const isAnswerSubmitted = conditionalAnswersSubmitted.includes(question.id);
  const radioError = !storedAnswer && isAnswerSubmitted;
  const checkboxError = storedAnswer && storedAnswer[0] === showCheckboxValue && isAnswerSubmitted;
  return (
    <>
      <p className="ch-width--12 ch-form__control-label ch-mb--2">
        {questionString}
      </p>
      <div className="ch-form__group">
        {radioError && (
          <div className="ch-form__group ch-form__group--error ch-mb--0">
            <span className="ch-form__control-validation ch-mb--1">
              Please at least one option
            </span>
          </div>
        )}

        <input
          id={`${groupName}-yes`}
          type="radio"
          name={`${groupName}NeedRepaired`}
          data-testid={`${groupName}-radio-yes`}
          value={showCheckboxValue}
          className="ch-radio"
          checked={
            (selectAnswer && selectAnswer[0] === showCheckboxValue)
          }
          onChange={({ target: { value } }) => {
            setToggleCheckbox(true);
            handleSelectChange(parseInt(value));
          }}
        />
        <label
          htmlFor={`${groupName}-yes`}
          className={`ch-radio__label ch-radio__label--primary`}
        >
          {showCheckboxLabel}
        </label>

        <input
          id={`${groupName}-no`}
          type="radio"
          name={`${groupName}NeedRepaired`}
          data-testid={`${groupName}-radio-no`}
          value={noDamage}
          className="ch-radio"
          checked={
            Boolean(selectAnswer) &&
            Boolean(noDamage) &&
            selectAnswer &&
            selectAnswer[0] === noDamage
          }
          onChange={({ target: { value } }) => {
            setToggleCheckbox(false);
            handleSelectChange(parseInt(value));
          }}
        />
        <label
          htmlFor={`${groupName}-no`}
          className={`ch-radio__label ch-radio__label--primary ch-ml--2`}
        >
          {noDamageLabel}
        </label>
      </div>
      {toggleCheckbox && (
        <div
          className={`ch-form__group ${
            checkboxError ? "ch-form__group--error" : ""
          }`}
        >
          <label
            htmlFor={`${groupName}Damaged`}
            className="ch-form__control-label"
          >
            {labelForCheckbox}
          </label>
          {checkboxError && (
            <span className="ch-form__control-validation  ch-mt--1">
              Please choose at least one option
            </span>
          )}
          <div
            className="ch-form__group ch-display--flex"
            style={{ flexDirection: "column" }}
          >
            {answersForCheckbox.map((answer: AnswerObject) => (
              <div key={answer.id}>
                <input
                  className="ch-checkbox"
                  id={answer.id.toString()}
                  name={answer.id.toString()}
                  type="checkbox"
                  value={answer.id}
                  checked={storedAnswer?.includes(answer.id)}
                  onChange={({ target: { value, checked } }) => {
                    handleCheckboxChange(parseInt(value), checked);
                  }}
                />
                <label
                  htmlFor={answer.id.toString()}
                  className="ch-checkbox__label ch-fs--3 ch-fw--400 ch-mt--2"
                >
                  {answer.label}
                </label>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};
